
import { UserLevel } from "@/types/gamification";

export const POINTS_PER_LEVEL = 100;

// Rebalanced point values - Goals are the PRIMARY source of points
export const POINTS = {
  // Core goal actions (main rewards)
  COMPLETE_TASK: 3,           // Reduced from 5
  COMPLETE_SUBTASK: 1,        // Reduced from 2
  COMPLETE_GOAL: 30,          // Increased from 25 - main reward
  CREATE_FIRST_GOAL: 10,      // Unchanged
  ADD_TASK_WITH_DATE: 2,      // Reduced from 3
  
  // Sharing & community
  SHARE_GOAL: 5,
  JOIN_COMMON_GOAL: 5,
  COMPLETE_COMMON_GOAL: 20,
  
  // Streaks (unchanged - good motivation)
  DAILY_STREAK_3: 10,
  DAILY_STREAK_7: 25,
  DAILY_STREAK_30: 100,
  
  // Certificates
  GENERATE_CERTIFICATE: 10,   // Reduced from 15
  
  // Admin
  ADMIN_APPRECIATION: 10,
  
  // Pledge points (unchanged)
  CREATE_PLEDGE: 3,
  ACCEPT_PLEDGE: 5,
  SUBMIT_PROOF_FIRST: 10,
  PROOF_APPROVED_RECIPIENT: 25,
  PROOF_APPROVED_GIVER: 5,
  
  // Daily Hub bonuses (modest - require full completion)
  COMPLETE_ALL_QUICK_TASKS: 5,    // Only for completing ALL tasks
  PERFECT_DAY: 8,                  // All tasks done, no carry forward
  COMPLETE_ALL_FAMILY_ACTIVITIES: 5, // Weekly bonus only

  // PWA install — one-time bonus for adding to home screen (server-deduped)
  INSTALL_PWA: 100,
} as const;

export const calculateLevel = (points: number): UserLevel => {
  const level = Math.floor(points / POINTS_PER_LEVEL) + 1;
  const currentPoints = points;
  const pointsToNextLevel = (level * POINTS_PER_LEVEL);
  
  return {
    level,
    currentPoints,
    pointsToNextLevel,
    badges: [] // Keep empty array for type compatibility
  };
};

export const getPointsBreakdown = () => POINTS;
